// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.questionnaires/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.questionnaires/route.tsx");
}
// REMIX HMR END

import { questionnaireListExample } from '@commural/shared-resources/schemas/business/Questionnaire.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import { Link } from '@remix-run/react';
import invariant from 'tiny-invariant';
import { Pagination } from '~/components/Pagination';
import { ScrollView } from '~/components/ScrollView';
import { useFormattedDate } from '~/hooks/useFormattedDate';
import { getCapitalized } from '~/utils.server';
import { getPaginated } from '~/utils/getPaginated';
import cn from './Questionnaires.module.css';
const TITLE = 'questionnaires';
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const {
    start,
    end,
    currentPage,
    pageCount
  } = getPaginated(new URL(request.url), questionnaireListExample.length);
  return {
    title,
    questionnaireList: questionnaireListExample.slice(start, end),
    currentPage,
    pageCount
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    questionnaireList,
    currentPage,
    pageCount
  } = useLoaderDataWithCache();
  return <ScrollView>
      <section className={cn.Questionnaires}>
        <header className={cn.Header}>
          <input placeholder="search" className="debug-block" />
          <button className="debug-block">create questionnaire</button>
        </header>
        <main>
          <table>
            <thead>
              <tr>
                <th>Questionnaire Name</th>
                <th>Created Date</th>
                <th>Expiration Date</th>
                <th>Respondents</th>
              </tr>
            </thead>
            <tbody>
              {questionnaireList.map(el => <QuestionnaireListItem key={el.id} questionnaire={el} />)}
            </tbody>
          </table>
        </main>
        <footer className={cn.Footer}>
          <Pagination currentPage={currentPage} pageCount={pageCount} />
        </footer>
      </section>
    </ScrollView>;
}
_s(Index, "TcvjzpM9iS6829BfhQHY13FbTio=", false, function () {
  return [useLoaderDataWithCache];
});
_c = Index;
function QuestionnaireListItem({
  questionnaire
}) {
  _s2();
  const {
    id,
    name,
    numberOfRespondents
  } = questionnaire;
  const createdAt = useFormattedDate(questionnaire.createdAt);
  const expiredAt = useFormattedDate(questionnaire.expiredAt);
  return <tr>
      <td>
        <Link to={id}>{name}</Link>
      </td>
      <td>{createdAt}</td>
      <td>{expiredAt}</td>
      <td>{numberOfRespondents}</td>
    </tr>;
}
_s2(QuestionnaireListItem, "50HgC3mHlVze4LehspCQfCqf5UQ=", false, function () {
  return [useFormattedDate, useFormattedDate];
});
_c2 = QuestionnaireListItem;
var _c, _c2;
$RefreshReg$(_c, "Index");
$RefreshReg$(_c2, "QuestionnaireListItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;